import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonCard = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

const SkeletonLine = styled.div`
  height: ${props => props.height || '20px'};
  width: ${props => props.width || '100%'};
  margin-bottom: ${props => props.marginBottom || '12px'};
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;

const SkeletonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #eef2f6;
`;

const PendenciasSkeleton = () => {
  return (
    <>
      {[1, 2, 3].map((i) => (
        <SkeletonCard key={i}>
          <SkeletonHeader>
            <SkeletonLine width="200px" height="24px" marginBottom="0" />
            <SkeletonLine width="100px" height="28px" marginBottom="0" />
          </SkeletonHeader>

          <SkeletonLine width="90%" height="16px" />

          <SkeletonGrid>
            <SkeletonLine width="150px" height="16px" marginBottom="0" />
            <SkeletonLine width="180px" height="16px" marginBottom="0" />
          </SkeletonGrid>
        </SkeletonCard>
      ))}
    </>
  );
};

export default PendenciasSkeleton;
